import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineArrowToBottomIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M19 20H5a1.0002 1.0002 0 0 0-.7071 1.7071C4.4804 21.8946 4.7348 22 5 22h14a1.0001 1.0001 0 0 0 0-2Zm-7.71-2.29c.0951.091.2072.1624.33.21a.94.94 0 0 0 .76 0 1.0012 1.0012 0 0 0 .33-.21l4-4a1.0041 1.0041 0 1 0-1.42-1.42L13 14.59V3a1.0002 1.0002 0 0 0-1.7071-.7071A1.0002 1.0002 0 0 0 11 3v11.59l-2.29-2.3a1.0052 1.0052 0 0 0-1.0943-.2177 1.0055 1.0055 0 0 0-.5434.5435A1.0036 1.0036 0 0 0 7.29 13.71l4 4Z"/>
  </SvgIcon>
}

export default LineArrowToBottomIcon
